import { getBootstrapData } from "@swa-ui/bootstrap";
import { dateFormats, swaDate } from "@swa-ui/date";
import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

import { getDateSchema } from "./getDateSchema";

const firstBookableDate = swaDate().set("date", swaDate().get("date"));

let schema;

export const carBookingFormSchema = () => {
  const carsLastBookableDaysRange = 330;
  const stationIds = getBootstrapData("car/car-locations-data").map((station) => station.id);
  const lastBookableDate = swaDate(firstBookableDate).add(carsLastBookableDaysRange, "day");

  if (!schema) {
    schema = yup.object().shape({
      pickupLocation: yup
        .string()
        .trim()
        .uppercase()
        .required()
        .oneOf(stationIds)
        .label(i18n("schema__PICKUP_LOCATION").toLowerCase()),
      returnLocation: yup
        .string()
        .trim()
        .uppercase()
        .required()
        .oneOf(stationIds)
        .label(i18n("schema__RETURN_LOCATION").toLowerCase()),
      pickupDate: yup
        .string()
        .required()
        .test("ValidDate", i18n("schema__VALID_PICKUP_DATE"), (pickupDate) =>
          swaDate(pickupDate, dateFormats.default, true).isValid()
        )
        .test(
          "FirstBookableDate",
          i18n("schema__ERROR_MIN_DATE", firstBookableDate.format("MM/DD/YYYY")),
          (pickupDate) => swaDate(pickupDate).isSameOrAfter(swaDate(), "day")
        )
        .test("LastBookableDate", i18n("schema__ERROR_MAX_DATE", lastBookableDate), (pickupDate) =>
          swaDate(pickupDate).isBefore(lastBookableDate, "day")
        )
        .label(i18n("schema__PICKUP_DATE").toLowerCase()),
      returnDate: getDateSchema(lastBookableDate)
        .required()
        .label(i18n("schema__RETURN_DATE").toLowerCase())
        .when("departDate", (departDate, returnDateTestSchema) =>
          returnDateTestSchema.test(
            "BeforeDepartureDate",
            i18n("schema__ERROR_MIN_DATE", firstBookableDate.format("MM/DD/YYYY")),
            (returnDateValue) =>
              swaDate(returnDateValue, dateFormats.default, true).isValid() &&
              swaDate(returnDateValue).isSameOrAfter(departDate, "day")
          )
        ),
      pickupTime: yup.string().required(),
      returnTime: yup
        .string()
        .required()
        .when(["pickupDate", "returnDate", "pickupTime"], (pickupDate, returnDate, pickupTime) => {
          let validation = "";

          if (swaDate(pickupDate).isSame(swaDate(returnDate), "day")) {
            validation = yup
              .string()
              .required()
              .test("BeforePickupTime", i18n("schema__ERROR_SAME_TIME"), (returnTime) =>
                swaDate(returnTime, "h:mma").isAfter(swaDate(pickupTime, "h:mma"))
              )
              .label(i18n("schema__RETURN_TIME").toLowerCase());
          } else {
            validation = yup.string().required();
          }

          return validation;
        }),
    });
  }

  return schema;
};
